import React from 'react';
import { useNuPlayerContext } from '../NuPlayerContext';
import classnames from 'classnames';

export const Playlist = () => {
  const { currentTrack, setIsPlaying, setCurrentTrack, tracks } = useNuPlayerContext();

  const handleClick = (track) => {
    setCurrentTrack(track);
    setIsPlaying(true);
  };

  return <div className="npPlaylist">
    <ul>
      { tracks.map((track, index) => {
        const trackClasses = classnames('npPlaylist__track', {
          isActive: currentTrack.title === track.title
        });
        const onKeyDown = (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            handleClick(track);
          }
        };

        return <li key={index} className={trackClasses} tabIndex={0} onKeyDown={onKeyDown} onClick={() => handleClick(track)}>
          <img src={track.thumbnail} alt={track.title}/>
          <div>
            <p>{track.title}</p>
            <small>{track.author}</small>
          </div>
        </li>
      })}
    </ul>
  </div>;
};
